import LeadForm from "./LeadForm";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://vingrace.com/wp-content/uploads/2023/08/banner.webp"
          alt=""
          className="w-full h-full object-cover"
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/40" />
      </div>

      <div className="relative z-10 py-14 sm:py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Left Content */}
            <div className="animate-fade-up">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-400 mb-4">
                India's #1 Stair Lift Provider
              </p>
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white leading-tight font-['Outfit']">
                Stair Lifts for Home &<br />
                <span className="text-amber-400">Commercial Spaces</span>
              </h1>
              <p className="mt-5 text-base sm:text-lg leading-relaxed text-stone-300 max-w-lg">
                Custom-fit chair lifts & wheelchair platform lifts for homes, offices & commercial buildings. Straight, curved & outdoor stairs — installed in 1-2 days. Trusted by <strong className="text-white">8,000+ families & businesses</strong> across India.
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-4">
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-4 py-2.5">
                  <span className="text-amber-400 font-bold text-lg">4.5</span>
                  <div className="flex text-amber-400">
                    {[1,2,3,4].map(i => <StarIcon key={i} filled />)}
                    <StarIcon half />
                  </div>
                  <span className="text-stone-300 text-sm ml-1">112 Google Reviews</span>
                </div>
                <div className="hidden sm:flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-4 py-2.5">
                  <span className="text-amber-400 font-bold text-lg">17+</span>
                  <span className="text-stone-300 text-sm">Years Experience</span>
                </div>
              </div>
              <p className="mt-5 text-stone-400 text-sm">
                Stairlift price starts at <span className="text-amber-400 font-bold text-lg">&#8377;1.55 Lakhs</span> onwards | Easy EMI | Free Site Survey
              </p>

              {/* Product images row for mobile */}
              <div className="mt-6 lg:hidden flex gap-3 overflow-x-auto pb-2">
                <img src="https://vingrace.in/wp-content/uploads/2025/12/Acorn-Superglide-130-Indoor-300x300.webp" alt="Acorn Superglide 130 Stairlift" className="w-24 h-24 rounded-xl object-cover border border-white/20" />
                <img src="https://vingrace.in/wp-content/uploads/2025/12/outdoor-stairlifts-300x300.webp" alt="Outdoor Stairlift India" className="w-24 h-24 rounded-xl object-cover border border-white/20" />
                <img src="https://vingrace.in/wp-content/uploads/2025/12/Otolift-curved-stairlifts-300x300.webp" alt="Curved Stairlift" className="w-24 h-24 rounded-xl object-cover border border-white/20" />
              </div>
            </div>

            {/* Right: Lead Form */}
            <div className="animate-slide-right">
              <LeadForm variant="hero" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function StarIcon({ filled, half }) {
  if (half) {
    return (
      <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
        <defs>
          <linearGradient id="halfGrad">
            <stop offset="50%" stopColor="currentColor" />
            <stop offset="50%" stopColor="#78716c" />
          </linearGradient>
        </defs>
        <path fill="url(#halfGrad)" d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    );
  }
  return (
    <svg className="w-4 h-4" viewBox="0 0 20 20" fill={filled ? "currentColor" : "#78716c"}>
      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
  );
}
